import { z } from "zod";

import { ExperienceDtoSchema } from "../../../dtos/experiences";
import { VariationDtoSchema } from "../../../dtos/variations";

export const PatchBuilderVariationsRequestPathParamSchema = z.object({
  experienceId: z.string().uuid(),
});

export type PatchBuilderVariationsRequestPathParamType = z.infer<
  typeof PatchBuilderVariationsRequestPathParamSchema
>;

export const PatchBuilderVariationsRequestBodySchema = z.object({
  variations: VariationDtoSchema.array(),
});

export type PatchBuilderVariationsRequestBodyType = z.infer<
  typeof PatchBuilderVariationsRequestBodySchema
>;

export const PatchBuilderVariationsResponseBodySchema = z.object({
  experiences: ExperienceDtoSchema.array(),
});

export type PatchBuilderVariationsResponseBodyType = z.infer<
  typeof PatchBuilderVariationsResponseBodySchema
>;
